import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dirArrow-r",
  "use": "dirArrow-r-usage",
  "viewBox": "0 0 23 6.01",
  "content": "<symbol viewBox=\"0 0 23 6.01\" id=\"dirArrow-r\"><title>dirArrow-r</title><path d=\"M524.5,306.5h17v-2l6,3-6,3v-2h-17Z\" transform=\"translate(-524.5 -304.49)\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dirArrow-r.svg
// module id = axVX
// module chunks = 264